/**
 * Created by mark on 05/03/2018.
 */


import React  from 'react';
import {Row , Col, Button} from 'react-bootstrap';
import {UserService} from '../../services';
import Translation from '../../store/internationalization-store.js';
import Popup from '../../components/popup/information_popup.js';
export default class PersonalInformation extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            old_password:"",
            password:"",
            confirm_password:"",
            saved:false,
            warning:false
        }

    }

    generate(){
        UserService.updatePassword().then(function(response){

            this.setState({
                show:true,
                username:response.username,
                password:response.password
            })
        }.bind(this))
    }

    render() {

        let saved = null;

        return <div>
            <Popup show={this.state.show}  onHide={()=>{this.setState({show:false})}}>
                <center><h5>{Translation.get(12652 , 'Teachers\' Login Details')}</h5></center><br/><center><h4>{String(Translation.get(22 , 'Username:') +' '+this.state.username)}</h4></center><center><h4>{String(Translation.get(23 , 'Password:') +' '+this.state.password)}</h4></center><br/><center><h5>{Translation.get(12770 , 'Please keep your details safe and secure')}</h5></center>
            </Popup>
                <Row>
                    <Col md={12}>
                        <Row>
                            <Col md={12}>
                                <Button block onClick={this.generate.bind(this)} block className="pull-right">{Translation.get(12653 , 'Generate New Password')}</Button>
                            </Col>
                        </Row>
                    </Col>
                </Row>
        </div>;
    }

}